/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Batch_RunsInputs */

const en_svchip_batch_runs = /** @type {(inputs: Svchip_Batch_RunsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batch runs`)
};

const ar_svchip_batch_runs = /** @type {(inputs: Svchip_Batch_RunsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تشغيلات دفعية`)
};

const bn_svchip_batch_runs = /** @type {(inputs: Svchip_Batch_RunsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ব্যাচ চালানো`)
};

const de_svchip_batch_runs = /** @type {(inputs: Svchip_Batch_RunsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batch-Läufe`)
};

const es_svchip_batch_runs = /** @type {(inputs: Svchip_Batch_RunsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ejecuciones en lote`)
};

const fr_svchip_batch_runs = /** @type {(inputs: Svchip_Batch_RunsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exécutions par lots`)
};

const pt_svchip_batch_runs = /** @type {(inputs: Svchip_Batch_RunsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Execuções em lote`)
};

const zh_svchip_batch_runs = /** @type {(inputs: Svchip_Batch_RunsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`批量运行`)
};

const tr_svchip_batch_runs = /** @type {(inputs: Svchip_Batch_RunsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toplu çalıştırmalar`)
};

const ru_svchip_batch_runs = /** @type {(inputs: Svchip_Batch_RunsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пакетные запуски`)
};

const pl_svchip_batch_runs = /** @type {(inputs: Svchip_Batch_RunsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uruchomienia wsadowe`)
};

/**
* | output |
* | --- |
* | "Batch runs" |
*
* @param {Svchip_Batch_RunsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_batch_runs = /** @type {((inputs?: Svchip_Batch_RunsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Batch_RunsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_batch_runs(inputs)
	if (locale === "bn") return bn_svchip_batch_runs(inputs)
	if (locale === "de") return de_svchip_batch_runs(inputs)
	if (locale === "es") return es_svchip_batch_runs(inputs)
	if (locale === "fr") return fr_svchip_batch_runs(inputs)
	if (locale === "pt") return pt_svchip_batch_runs(inputs)
	if (locale === "zh") return zh_svchip_batch_runs(inputs)
	if (locale === "tr") return tr_svchip_batch_runs(inputs)
	if (locale === "ru") return ru_svchip_batch_runs(inputs)
	if (locale === "pl") return pl_svchip_batch_runs(inputs)
	return en_svchip_batch_runs(inputs)
});